// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__iMiAM","header":"ClearentDisclaimer_header__2Vfja","inner":"ClearentDisclaimer_inner__15Sg6"};